import React, { useState } from 'react';
import { Mail, Phone, MapPin, Github, Linkedin, Twitter } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const web3FormsAccessKey = '2af02a95-1df4-448b-b5e2-93b8bf454c40';

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setSubmitStatus('Please fill in all fields.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: web3FormsAccessKey,
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        })
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok && data.success) {
        setSubmitStatus('Message sent successfully. I will get back to you soon.');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus(data.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitStatus('Unable to send message right now. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section slide-in-section">
      <div className="container">
        <div className="section-header">
          <span className="section-number">05</span>
          <h2 className="section-title">GET IN TOUCH</h2>
          <p className="section-subtitle">Let's discuss your next project</p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3 className="contact-info-title">Contact Information</h3>

            <div className="contact-item">
              <div className="contact-icon-box">
                <Mail size={24} />
              </div>
              <div>
                <div className="contact-label">Email</div>
                <div className="contact-value">tejeesh24@gmail.com</div>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <Phone size={24} />
              </div>
              <div>
                <div className="contact-label">Phone</div>
                <div className="contact-value">7989126817</div>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <MapPin size={24} />
              </div>
              <div>
                <div className="contact-label">Location</div>
                <div className="contact-value">Hyderabad, India</div>
              </div>
            </div>

            <div className="social-section">
              <h4 className="social-title">Follow Me</h4>
              <div className="social-icons">
                <a href="https://github.com/tejeeshsai" target="_blank" rel="noopener noreferrer" className="social-icon-box">
                  <Github size={24} />
                </a>
                <a href="https://www.linkedin.com/in/tejeesh-sai-reddi-b70a5b223/" target="_blank" rel="noopener noreferrer" className="social-icon-box">
                  <Linkedin size={24} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon-box">
                  <Twitter size={24} />
                </a>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h3 className="form-title">Send a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Your name"
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="your.email@example.com"
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  placeholder="Project inquiry"
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Tell me about your project..."
                  rows="5"
                  className="form-textarea"
                  required
                />
              </div>
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
              {submitStatus && <p className="form-status">{submitStatus}</p>}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;